import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { PropertyServices, DemandServices, PersonServices, ProjectServices } from '../../../services';
import { ReportServices } from '../../../services/report.services';
import { IPrintTemplateState, PrintTemplateState } from './states.store';

/** SEND MESSAGE CHILD component */
import sendMessageActions from './actions.store';
import sendMessageGetters from './getters.store';
import sendMessageMutations from './mutations.store';

/** define module */
export class PrintTemplateModule<RootState> implements Module<IPrintTemplateState, RootState>{
  namespaced: boolean;
  state: IPrintTemplateState;
  getters: GetterTree<IPrintTemplateState, RootState>;
  actions: ActionTree<IPrintTemplateState, RootState>;
  mutations: MutationTree<IPrintTemplateState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new PrintTemplateState({ service: new ReportServices, propertyService: new PropertyServices, demandService: new DemandServices, personService: new PersonServices, projectService: new ProjectServices});

    this.mutations = {
      ...sendMessageMutations,
    };

    this.actions = {
      ...sendMessageActions,
    };

    this.getters = {
      ...sendMessageGetters,
    };
  }
}
